var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-menu",modifiers:{"sidebar-menu":true}}],staticClass:"menu"},[_c('b-icon',{attrs:{"scale":"2","icon":"list","color":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }